import { InstrumentParams } from '../../types/common';
import { supports } from './consts';

export type BankInstrumentId = typeof supports[number];

export interface TabProps {
  isActive: boolean;
  onClick: () => void;
}

export interface ContentProps {
  parameters: InstrumentParams;
}

export interface BankInstrumentComponents {
  Tab: React.FC<TabProps>;
  Content: React.FC<ContentProps>;
}
